<article class="fans-list-container">
  <header *ngIf="deviceDeploymentSummary.fan && !processingFansFlag">
    <div *ngIf="formSuccess" id="success-main-container">
      <div class="container-box" id="success-container">
        <div class="alert valign-children-middle" id="alert-success-container">
          <div class="alert-success">
            <i class="icon-approval" aria-hidden="true"></i>
          </div>
          <div id="success-message-container">
            <!-- <h6 tabindex="-1" id="success-heading">{{deviceDeploymentSummary.success}}</h2> -->
            <p id="success-message">{{deviceDeploymentSummary.successMsg}}</p>
          </div>
        </div>
      </div>
    </div>
    <div *ngIf='showError' class='alert valign-children-middle error-alert' role='alert'>
      <div class='alert-error' role='img' aria-label='Error'>
        <i class='icon-badgealert' role='img' aria-label='Error'></i>
      </div>
      <div class='alert-content'>
        <p>{{deviceDeploymentSummary.errorMsg}}</p>
      </div>
      <button class='close' (click)='showError = !showError' aria-label='Close'></button>
    </div>
    <div class="tileHeader" id="{{this.deviceDeploymentSummary.fan}}"><strong>Foundation account:
        {{deviceDeploymentSummary.fan}}</strong></div>
    <a *ngIf="deviceDeploymentSummary.profile && !oemStatus" (click)="viewProfile(deviceDeploymentSummary.profile)"
      href="javascript:void(0)"
      [checkRole]="deviceDeploymentSummary.fieldpermission.profile">{{deviceDeploymentSummary.profile}}</a>
    <br>
    <div *ngIf="deviceDeploymentSummary.fan && oemStatus && !addpAllow" class="grid-table" cellspacing="0">
      <table class="tablenew1 tableoem">
        <tr>
          <td class="inventory-label" *ngIf="abm"><strong>{{deviceDeploymentSummary.prodName}}</strong>
            <!-- [ngClass]="{'disable-link': disableChangeLink}" -->
            {{deviceDeploymentSummary.accountId}}</td>
          <td *ngIf="(abm && !addpAllow)"><a
              [ngClass]="{'disable-link': deviceDeploymentSummary.accountId === 'Pending'}" routerLink="/manageInventory/manageAccounts"
              (click)="selectedFan(deviceDeploymentSummary.fan,deviceDeploymentSummary.accountId)">
              Change </a></td>
        </tr>
        <tr>
          <td class="inventory-label" *ngIf="omeabm"><strong>{{omeAbmLabel}}</strong>
            {{omeAbmId}}</td>
          <td *ngIf="omeabm && !addpAllow"><a [ngClass]="{'disable-link': omeAbmId === 'Pending'}"
              routerLink="/manageInventory/manageAccounts"
              (click)="selectedFan(deviceDeploymentSummary.fan,omeAbmId)">
              Change </a></td>
        </tr>
        <tr>
          <td class="inventory-label" *ngIf="kme"> <strong>{{deviceDeploymentSummary.prodName}} </strong>
            {{deviceDeploymentSummary.accountId}}</td>
        </tr>
        <tr>
          <td class="inventory-label" *ngIf="omekme"><strong>{{omeKmeLabel}}</strong>
            {{omeKmeId}}</td>
        </tr>
        <tr>
          <td class="inventory-label" *ngIf="ztp"><strong>{{deviceDeploymentSummary.prodName}} </strong>
            {{deviceDeploymentSummary.accountId}}</td>
        </tr>
        <tr>
          <td class="inventory-label" *ngIf="omeztp"><strong>{{omeZtpLabel}}</strong>
            {{omeZtpId}}</td>
        </tr>
        <!-- <tr>
            <td *ngIf="abm && !addpAllow"><a href="manageInventory/manageAccounts"
                (click)="selectedFan(deviceDeploymentSummary.fan,deviceDeploymentSummary.accountId)">
                Change</a></td>
          </tr> -->

        <!-- <tr>
                    <td class="inventory-label" *ngIf="omeabm"><b>{{deviceDeploymentSummary.ome}}</b>
                      {{deviceDeploymentSummary.omeId}}</td>
                  </tr> -->

      </table>

      <!-- <table class="tablenew1 tableoem">
          <tr>
            <td class="inventory-label" *ngIf="abm"><b>{{deviceDeploymentSummary.prodName}}  </b>
              {{deviceDeploymentSummary.accountId}}</td>
            <td class="inventory-label" *ngIf="kme"> <b>{{deviceDeploymentSummary.prodName}} </b>
              {{deviceDeploymentSummary.accountId}}</td>
            <td class="inventory-label" *ngIf="ztp"><b>{{deviceDeploymentSummary.prodName}}  </b>
              {{deviceDeploymentSummary.accountId}}</td>
            <td *ngIf="abm && !addpAllow"><a href="manageInventory/manageAccounts"
                (click)="selectedFan(deviceDeploymentSummary.fan,deviceDeploymentSummary.accountId)">
                Change</a></td>
          </tr>
          
          <tr>
            <td class="inventory-label"><b>{{deviceDeploymentSummary.ome}}</b>
              {{deviceDeploymentSummary.omeId}}</td>
          </tr>

        </table> -->


    </div>
  </header>
  <header *ngIf="processingFansFlag">
    <div class="tileHeader" id="{{this.deviceDeploymentSummary.fan}}"><strong>Foundation account:
        {{deviceDeploymentSummary.fan[0].fan}}</strong></div>
    <table class="tablenew1 tableoem">
      <tr *ngIf="abm">
        <td class="inventory-label"><strong>Apple Organization ID: </strong>
          {{deviceDeploymentSummary.fan[0].emmAccountId}}</td>
      </tr>
      <tr *ngIf="kme">
        <td class="inventory-label"><strong>Knox Mobile Enrollment ID: </strong>
          {{deviceDeploymentSummary.fan[0].emmAccountId}}</td>
      </tr>
      <tr *ngIf="ztp">
        <td class="inventory-label"><strong>GOOGLE ID: </strong>
          {{deviceDeploymentSummary.fan[0].emmAccountId}}</td>
      </tr>
      <tr *ngIf="omeabm">
        <td class="inventory-label"><strong>{{omeAbmLabel}}</strong>
          {{omeAbmId}}</td>
      </tr>
      <tr *ngIf="omekme">
        <td class="inventory-label"><strong>{{omeKmeLabel}}</strong>
          {{omeKmeId}}</td>
      </tr>
      <tr *ngIf="omeztp">
        <td class="inventory-label"><strong>{{omeZtpLabel}}</strong>
          {{omeZtpId}}</td>
      </tr>
    </table>

  </header>
  <!-- <section *ngIf="deviceDeploymentSummary.status">
    <p [ngClass]="{ tileHeader: addTileHeader }" >{{deviceDeploymentSummary.status}}</p>
  </section> -->
  <section *ngIf="deviceDeploymentSummary.status === 'Add accounts'">
    <app-legend [data]="pData"></app-legend>
  </section>

  <section class="deviceStatus">
    <div class="staus" *ngIf="!deviceDeploymentSummary.hideDeviceChart">
      <app-status-bar [data]="progressChartData" [leftLabel]="leftLabel"></app-status-bar>
    </div>
    <div class="legend" *ngIf="!deviceDeploymentSummary.hideLegend && progressChartData.length > 0">
      <app-legend class="col-sm-6 col-md-6" [data]="legendData.left"></app-legend>
      <app-legend class="col-sm-6 col-md-6" [data]="legendData.right"></app-legend>
    </div>
  </section>
  <div *ngIf="deviceDeploymentSummary.fan && oemStatus" class="grid-table" cellspacing="0">
    <table class="tablenew tableoem">
      <tr>
        <td class="inventory-label notification-label">
          <strong>{{deviceDeploymentSummary.notifications}}</strong>{{deviceDeploymentSummary.notificationstatus}}
        </td>

        <td *ngIf="!addpAllow && !processingFansFlag"><a [ngClass]="{'disable-link':  changedisable}"
            href="manageInventory/managenotification"
            (click)="selectedProfile(deviceDeploymentSummary.fan,deviceDeploymentSummary.profile,deviceDeploymentSummary.notificationstatus)">
            Change
          </a></td>

      </tr>
    </table>
  </div>
  <section *ngIf="deviceDeploymentSummary.statusMessage || deviceDeploymentSummary.systemFailure">
    <div class="row systemFailure"
      *ngIf="systemFailure && (deviceDeploymentSummary.status !== 'Set up accounts' || deviceDeploymentSummary.systemFailure) ">
      <div class="alert-icon">
        <i aria-label="Alert" class="icon-alert .ico" role="img"></i>
      </div>
      <div class="extra-content">
        <p>{{deviceDeploymentSummary.systemFailure}}</p>
      </div>
    </div>
    <!-- this is if the status is PROCESSING -->
    <div class="row systemFailure"
      *ngIf="!systemFailure && deviceDeploymentSummary.status !== 'Set up accounts' || (deviceDeploymentSummary.status === 'Set up accounts' && mdmDetails.productCode === 'ADDPMDM')">
      <div class="alert-icon" *ngIf="deviceDeploymentSummary.statusMessage">
        <i aria-label="Alert" class="icon-alert .ico" role="img"></i>
      </div>
      <div class="extra-content">
        <p>{{deviceDeploymentSummary.statusMessage}}</p>
      </div>
    </div>
    <p *ngIf="deviceDeploymentSummary.status !== 'Set up accounts' || deviceDeploymentSummary.statusMessageHeader ">
      {{deviceDeploymentSummary.statusMessageHeader}}</p>
    <p *ngIf="deviceDeploymentSummary.status === 'Set up accounts' && mdmDetails.productCode === 'ADDPZTE'">
      {{readyToSetupFansCount}} {{deviceDeploymentSummary.statusMessageZTE}}</p>
  </section>
  <footer class="text-center" *ngIf="deviceDeploymentSummary.btnText">
    <button (click)="navigate(deviceDeploymentSummary)" class="btn btn-default" type="button"
      [attr.aria-describedby]="deviceDeploymentSummary.fan" [disabled]="!isDeviceCount"
      [checkRole]="deviceDeploymentSummary.fieldpermission.btnPermission">{{deviceDeploymentSummary.btnText}}</button>
  </footer>
</article>